import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, CheckCircle2 } from 'lucide-react';
const PURCHASES = [{
  name: 'María',
  city: 'Buenos Aires',
  time: '3 minutos'
}, {
  name: 'Juan',
  city: 'Córdoba',
  time: '7 minutos'
}, {
  name: 'Lucía',
  city: 'Rosario',
  time: '12 minutos'
}, {
  name: 'Pedro',
  city: 'Mendoza',
  time: '5 minutos'
}, {
  name: 'Ana',
  city: 'La Plata',
  time: '9 minutos'
}, {
  name: 'Diego',
  city: 'Tucumán',
  time: '2 minutos'
}, {
  name: 'Florencia',
  city: 'Mar del Plata',
  time: '15 minutos'
}, {
  name: 'Martín',
  city: 'Salta',
  time: '6 minutos'
}];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isDismissed, setIsDismissed] = useState(false);
  useEffect(() => {
    if (isDismissed) return;
    const initialTimeout = setTimeout(() => {
      setIsVisible(true);
    }, 5000);
    const cycleInterval = setInterval(() => {
      if (isDismissed) return;
      setIsVisible(false);
      setTimeout(() => {
        if (isDismissed) return;
        setCurrentIndex(prev => (prev + 1) % PURCHASES.length);
        setIsVisible(true);
      }, 2000);
    }, 8000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(cycleInterval);
    };
  }, [isDismissed]);
  useEffect(() => {
    if (isVisible && !isDismissed) {
      const hideTimeout = setTimeout(() => {
        setIsVisible(false);
      }, 5000);
      return () => clearTimeout(hideTimeout);
    }
  }, [isVisible, isDismissed]);
  if (isDismissed) return null;
  const currentPurchase = PURCHASES[currentIndex];
  return <AnimatePresence data-id="element-243">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20,
      x: -20
    }} transition={{
      duration: 0.5
    }} className="fixed bottom-4 left-4 z-50 max-w-xs w-full" data-id="element-244">
          <div className="bg-white rounded-lg shadow-2xl border border-gray-200 p-4 flex items-start gap-3 relative overflow-hidden" data-id="element-245">
            <button onClick={() => setIsDismissed(true)} className="absolute top-1 right-1 text-gray-400 hover:text-gray-600 p-1" data-id="element-246">
              <X size={14} data-id="element-247" />
            </button>

            <div className="flex-shrink-0 relative" data-id="element-248">
              <img src="https://cdn.magicpatterns.com/uploads/eCDgi54Sbbi4qSmorPopP3/mockups_geografia_.png" alt="Product" className="w-12 h-12 object-cover rounded-md border border-gray-100" data-id="element-249" />
              <div className="absolute -bottom-1 -right-1 bg-green-500 rounded-full p-0.5 border-2 border-white" data-id="element-250">
                <CheckCircle2 size={10} className="text-white" data-id="element-251" />
              </div>
            </div>

            <div className="flex-1 pr-4" data-id="element-252">
              <p className="text-sm font-bold text-gray-800 leading-tight" data-id="element-253">
                {currentPurchase.name} de {currentPurchase.city}
              </p>
              <p className="text-xs text-gray-600 mt-0.5" data-id="element-254">
                compró el Kit hace{' '}
                <span className="font-medium text-green-600" data-id="element-255">
                  {currentPurchase.time}
                </span>
              </p>
              <div className="flex items-center mt-1" data-id="element-256">
                <div className="flex" data-id="element-257">
                  {[1, 2, 3, 4, 5].map(i => <span key={i} className="text-[#fbbf24] text-[10px]" data-id="element-258">
                      ★
                    </span>)}
                </div>
                <span className="text-[10px] text-gray-400 ml-1" data-id="element-259">
                  Verificado
                </span>
              </div>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}